module.exports = __webpack_public_path__ + "static/haas-profile-90912d168e252b7b992fa59a60ced981.jpg";